module.exports = __webpack_public_path__ + "assets/ac111633e1a26373c6a81d970650a825.webm";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/images-desktop/celebrations/confetti.webm
 ** module id = 63
 ** module chunks = 0
 **/